import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Icons
import CheckIcon from '../../icons/check.svg';

// Styles
import styles from './CheckboxFieldRed.styl';

const cx = classNames.bind(styles);

export default function CheckboxFieldRed(props) {
  const { className, children, label, name, inputRef, ...otherProps } = props;

  const inputProps = {
    ...otherProps,
    ref: inputRef,
    type: 'checkbox',
    name,
    id: name,
  };

  return (
    <label
      className={cx('CheckboxFieldRed', className, {
        CheckboxField_checked: otherProps.value,
        CheckboxField_disabled: otherProps.disabled,
      })}
      htmlFor={name}
    >
      <input className={cx('CheckboxField__input')} {...inputProps} />
      <div className={cx('CheckboxField__check')}>
        {otherProps.value && <CheckIcon className={cx('CheckboxField__icon')} />}
      </div>
      <div className={cx('CheckboxField__label')}>{label}</div>
    </label>
  );
}

CheckboxFieldRed.defaultProps = {
  className: '',
  type: 'checkbox',
};

CheckboxFieldRed.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  inputRef: PropTypes.string,
  big: PropTypes.bool,
  children: PropTypes.any,
};
